import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col, FormGroup, Label, Input } from "reactstrap";

export default function InsuranceSection({ setFieldValue, insuranceDetails }) {
  const [formData, setFormData] = useState({});
  const { settings } = useSelector((state) => state.gym.gym);

  const handleRadioChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleTextChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  useEffect(() => {
    setFieldValue("insuranceDetails", formData);
  }, [formData, setFieldValue]);
  useEffect(() => {
    if (insuranceDetails && Object.keys(insuranceDetails).length > 0) {
      setFormData(insuranceDetails);
    }
  }, [insuranceDetails]);
  return (
    <div className="mt-3">
      {settings?.memberRegistration?.fields?.insuranceDetails?.enabled && (
        <Row
          key={"hasInsurance"}
          className="g-3 mb-3 align-items-center pl-2"
          style={{ height: "50px" }}
        >
          <Col md={3}>
            <Label className="fw-semibold mb-0" style={{ fontSize: "14px" }}>
              Has Insurance?
            </Label>
          </Col>

          <Col md={2}>
            <div className="d-flex gap-3">
              <FormGroup check className="mb-0 mr-3">
                <Input
                  type="radio"
                  name={"hasInsurance"}
                  value="yes"
                  id={`${"hasInsurance"}-yes`}
                  checked={formData["hasInsurance"] === "yes"}
                  onChange={(e) =>
                    handleRadioChange("hasInsurance", e.target.value)
                  }
                  className="mr-1"
                />
                <Label check htmlFor={`${"hasInsurance"}-yes`}>
                  Yes
                </Label>
              </FormGroup>

              <FormGroup check className="mb-0">
                <Input
                  type="radio"
                  name={"hasInsurance"}
                  value="no"
                  id={`${"hasInsurance"}-no`}
                  checked={formData["hasInsurance"] === "no"}
                  onChange={(e) =>
                    handleRadioChange("hasInsurance", e.target.value)
                  }
                />
                <Label check htmlFor={`${"hasInsurance"}-no`}>
                  No
                </Label>
              </FormGroup>
            </div>
          </Col>
        </Row>
      )}
      {console.log("formData", formData, {
        see: settings?.memberRegistration?.fields?.insuranceDetails?.fields,
      })}
      {formData?.hasInsurance === "yes" && (
        <>
          <Row className="g-3 mt-3 pt-3 ">
            {settings?.memberRegistration?.fields?.insuranceDetails?.fields
              ?.cardNumber?.enabled && (
              <Col key={"insuranceCardNumber"} md={12}>
                <FormGroup className="custom-inputs mb-3">
                  <Input
                    type="text"
                    value={formData["insuranceCardNumber"]}
                    onChange={(e) =>
                      handleTextChange("insuranceCardNumber", e.target.value)
                    }
                    placeholder={"Card Number"}
                    className="form-control"
                  />
                  <Label>{"Card Number"}</Label>
                </FormGroup>
              </Col>
            )}
            {settings?.memberRegistration?.fields?.insuranceDetails?.fields
              ?.insuranceCompany?.enabled && (
              <Col key={"insuranceCompany"} md={12}>
                <FormGroup className="custom-inputs mb-3">
                  <Label className="fw-semibold mb-2">Insurance Company</Label>
                  <Input
                    type="select"
                    value={formData["insuranceCompany"]}
                    onChange={(e) =>
                      handleTextChange("insuranceCompany", e.target.value)
                    }
                    className="form-control"
                  >
                    <option value="">Select Insurance Company</option>
                    {settings?.memberRegistration?.fields?.insuranceDetails?.insuranceCompanyList.map(
                      (option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      )
                    )}
                  </Input>
                </FormGroup>
              </Col>
            )}
            {settings?.memberRegistration?.fields?.insuranceDetails?.fields
              ?.Copayment?.enabled && (
              <Col key={"Copayment"} md={12}>
                <FormGroup className="custom-inputs mb-3">
                  <Label className="fw-semibold mb-2">Insurance Company</Label>
                  <Input
                    type="select"
                    value={formData["Copayment"]}
                    onChange={(e) =>
                      handleTextChange("Copayment", e.target.value)
                    }
                    className="form-control"
                  >
                    <option value="">Select Insurance Copayment</option>
                    {[0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50].map(
                      (option) => (
                        <option key={option} value={option}>
                          {option}%
                        </option>
                      )
                    )}
                  </Input>
                </FormGroup>
              </Col>
            )}
          </Row>
        </>
      )}
    </div>
  );
}
